import UploadFileWithSteps from "components/UploadFileWithSteps/UploadFileWithSteps";

const UploadFileBlock = ({
    file,
    changeForm, 
    errors,
    title,
    description
}) => {
    const changeFileData = (newFile) => {
        changeForm({ ...newFile });
    }
    return (
        <>
            <UploadFileWithSteps 
                description={description}
                title={title}
                file={file}
                error={errors.fileData}
                errorText="Es necesario que descargues y subas el archivo modificado con los errores para poder guardar y finalizar."
                onChange={changeFileData}
                formatFile="/Documents/Eventos/Carga_masiva/eventos_formato_registros_carga_masiva.xlsx"/>
        </>
    );
}

export default UploadFileBlock;